const MINUTE_MS = 60 * 1000;

/**
 * The API sends UTC timestamps without a zone, and 0001-01-01 for "never".
 * @returns {number|null} epoch ms, or null when there is no date
 */
export const parseUtcTimestamp = (value) => {
    if (!value || String(value).startsWith('0001-01-01')) return null;
    const text = String(value);
    const hasZone = /(Z|[+-]\d{2}:?\d{2})$/i.test(text);
    const time = Date.parse(hasZone ? text : `${text}Z`);
    return Number.isNaN(time) ? null : time;
};

const plural = (count, unit) => `${count} ${unit}${count === 1 ? '' : 's'} ago`;

/**
 * (3158) How long ago something happened: "12 mins ago", "2 hours ago",
 * "3 days ago". Under a minute reads "Just now".
 */
export const formatTimeSince = (time, now) => {
    const minutes = Math.max(0, Math.floor((now - time) / MINUTE_MS));
    if (minutes < 1) return 'Just now';
    if (minutes < 60) return plural(minutes, 'min');

    const hours = Math.floor(minutes / 60);
    if (hours < 24) return plural(hours, 'hour');

    return plural(Math.floor(hours / 24), 'day');
};

const pad = (value) => String(value).padStart(2, '0');

/** (3158) DD/MM/YYYY HH:MM UTC, the dashboard's timestamp format. */
export const formatUtcTimestamp = (time) => {
    const date = new Date(time);
    return `${pad(date.getUTCDate())}/${pad(date.getUTCMonth() + 1)}/${date.getUTCFullYear()} ${pad(date.getUTCHours())}:${pad(date.getUTCMinutes())} UTC`;
};
